import React from 'react';
import Setup from './Setup';
import Results from './Results';
import {
  SIMULATION_VIEW_SETUP,
  SIMULATION_VIEW_INPROGRESS,
  SIMULATION_VIEW_FINISHED,
} from '../../constants/simulation';

const Simulation = React.memo(({ view, ...params }) => {
  let simulationComponent = <span>[no unity renderer provided]</span>;
  switch (view) {
    case SIMULATION_VIEW_SETUP:
      simulationComponent = <Setup {...params} />;
      break;
    case SIMULATION_VIEW_FINISHED:
      simulationComponent = (
        <Results
          setMainPage={params.setMainPage}
          results={params.results}
          reset={params.resetSimulation}
        />
      );
      break;
    case SIMULATION_VIEW_INPROGRESS:
    default:
      // in progress only shows the unity content, and we default to blank if the view
      // is some other (unknown and unexpected) value
      simulationComponent = null;
      break;
  }

  return simulationComponent;
});

Simulation.displayName = 'Simulation';

export default Simulation;
